/** Lightweight runtime source of truth for Stripe trigger event counts. */
export const SUPPORTED_STRIPE_EVENTS = [
  'checkout.session.async_payment_succeeded',
  'checkout.session.async_payment_failed',
  'checkout.session.completed',
  'customer.created',
  'customer.updated',
  'customer.deleted',
  'customer.subscription.created',
  'customer.subscription.updated',
  'customer.subscription.paused',
  'customer.subscription.resumed',
  'customer.subscription.trial_will_end',
  'customer.subscription.deleted',
  'invoice.created',
  'invoice.paid',
  'invoice.payment_failed',
  'invoice.upcoming',
  'quote.finalized',
  'quote.accepted',
  'quote.canceled',
  'charge.refunded',
  'refund.created',
  'payment_intent.payment_failed',
] as const

export type SupportedStripeEventType = (typeof SUPPORTED_STRIPE_EVENTS)[number]

export const SUPPORTED_STRIPE_EVENT_SET: ReadonlySet<string> = new Set(
  SUPPORTED_STRIPE_EVENTS
)
